var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.relatedProducts !== null
    ? _c(
        "div",
        { staticClass: "related-products mt-5" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("h2", { staticClass: "text-center mb-4" }, [
                        _vm._v("Related Products"),
                      ]),
                      _vm._v(" "),
                      _c("carousel", {
                        class: _vm.theme,
                        attrs: {
                          items: _vm.relatedProducts,
                          loading: false,
                          "num-items": 4,
                          "carousel-classes": "products-carousel",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ item }) {
                                return [
                                  _c(_vm.carouselItemLayout(item), {
                                    tag: "component",
                                    attrs: {
                                      item: item,
                                      "hover-card-enabled":
                                        _vm.hoverCardSetting,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          436041653
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }